import apiClient from '@/services/api_client';

export type Quota = {
    id: string;
    tenant_id: string;
    name: string;
    value_usd: number;
};

export type CreateQuotaPayload = {
    name: string;
    value_usd: number;
};

export type UpdateQuotaPayload = {
    name?: string;
    value_usd?: number;
};

export async function getUserIndexationQuotas(tenantId: string) {
    const url = '/indexation_quotas/user?tenant_id=' + tenantId;
    const response = await apiClient.get(url);
    return await response.json();
}

export async function getQuotas(tenantId: string): Promise<Quota[]> {
    const response = await apiClient.get(
        `/quotas?tenant_id=${encodeURIComponent(tenantId)}`
    );
    return await response.json();
}

export async function createQuota(
    tenantId: string,
    payload: CreateQuotaPayload
): Promise<Quota> {
    return await apiClient.post(
        `/quotas?tenant_id=${encodeURIComponent(tenantId)}`,
        payload
    );
}

export async function updateQuota(
    tenantId: string,
    quotaId: string,
    payload: UpdateQuotaPayload
): Promise<Quota> {
    return await apiClient.patch(
        `/quotas/${encodeURIComponent(quotaId)}?tenant_id=${encodeURIComponent(tenantId)}`,
        payload
    );
}

export async function deleteQuota(
    tenantId: string,
    quotaId: string
): Promise<void> {
    await apiClient.delete(
        `/quotas/${encodeURIComponent(quotaId)}?tenant_id=${encodeURIComponent(tenantId)}`,
        {}
    );
}
